import { IPagination } from 'app/types/common';

export interface IPaymentRequest {
  id: string;
  type: string;
  description: string;
  amount: number;
  dueAt: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  collected: number;
  pending: number;
  pendingAmount: number;
  totalAmount: number;
  collectedAmount: number;
  total: number;
  numberOfPeople: number;
  paymentType: string;
  paymentCategory: string;
  competitionName: string;
  notificationLog: any;
  notificationConfiguration: any;
  metadata: {};
}
export interface IPaymentRequestsState {
  readonly paymentRequestsById?: any;
  readonly paymentRequestIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectPaymentRequestLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddPaymentRequest?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentRequestIds?: string[];
  readonly currentPaymentRequestId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IPaymentRequestsSelector extends IPaymentRequestsState {
  readonly currentPaymentRequest?: any;
  readonly currentFormPaymentRequest?: any;
  readonly getPaymentRequestsFilteredByTagInSelectFormat?: any;
  readonly paymentRequestsByIdInSelectFormat?: any;
}

export enum PaymentRequestsActionTypes {
  GET_ALL_PAYMENT_REQUESTS_REQUESTED = 'redux-app/payment-requests/GET_ALL_PAYMENT_REQUESTS_REQUESTED',
  GET_ALL_PAYMENT_REQUESTS_PENDING = 'redux-app/payment-requests/GET_ALL_PAYMENT_REQUESTS_PENDING',
  GET_ALL_PAYMENT_REQUESTS_SUCCESS = 'redux-app/payment-requests/GET_ALL_PAYMENT_REQUESTS_SUCCESS',
  GET_ALL_PAYMENT_REQUESTS_FAIL = 'redux-app/payment-requests/GET_ALL_PAYMENT_REQUESTS_FAIL',
  GET_PAYMENT_REQUEST_REQUESTED = 'redux-app/payment-requests/GET_PAYMENT_REQUEST_REQUESTED',
  GET_PAYMENT_REQUEST_PENDING = 'redux-app/payment-requests/GET_PAYMENT_REQUEST_PENDING',
  GET_PAYMENT_REQUEST_SUCCESS = 'redux-app/payment-requests/GET_PAYMENT_REQUEST_SUCCESS',
  GET_PAYMENT_REQUEST_FAIL = 'redux-app/payment-requests/GET_PAYMENT_REQUEST_FAIL',
  SELECT_PAYMENT_REQUEST_REQUESTED = 'redux-app/payment-requests/SELECT_PAYMENT_REQUEST_REQUESTED',
}

// export interface IPaymentRequest {
//   id: string;
//   organisationName: string;
//   competitionName: string;
//   createdOn: string;
//   updatedOn: string;
//   dueOn: string;
//   paidOn: string;
//   collectedOtherOn: string;
//   refundedOn: string;
//   transferredOn: string;
//   paymentStatus: string;
//   paymentStatusHumanised: string;
//   paymentStatusColour: string;
//   paymentType: string;
//   paymentTypeHumanised: string;
//   description: string;
//   notificationConfiguration: {
//     sendSmsInitialNotificationOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendEmailInitialNotificationOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendSmsDueReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendEmailDueReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendSms3DayReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendEmail3DayReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendSms1DayReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//     sendEmail1DayReminderOrgCustomers: {
//       scheduled: boolean;
//       timeframe: string;
//     };
//   };
//   notificationLog: {
//     sendSmsInitialNotificationOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendEmailInitialNotificationOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendSmsDueReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendEmailDueReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendSms3DayReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendEmail3DayReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendSms1DayReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//     sendEmail1DayReminderOrgCustomers: {
//       sent: boolean;
//       sentOn: string;
//     };
//   };
//   amountInCents: number;
//   amountInDollars: number;
//   totalAmountRequestedInDollars: number;
//   totalAmountRequestedInCents: number;
//   numberOfPayees: number;
//   totalAmountCollectedInDollars: number;
//   totalAmountCollectedInCents: number;
//   numberOfCollectedPayees: number;
//   totalNumberCollected: number;
//   totalNetAmountCollectedInCents: number;
// }

export default null;
